type LanguagePickerLocaleSources = {
  textLocales: string[];
  subtitleLocales: string[];
  mediumLocales: string[];
};

/**
 * Locales shown in the onboarding language modal — union of every locale
 * the course supports for interface, captions, or audio narration.
 */
export function getLanguagePickerLocales({
  textLocales,
  subtitleLocales,
  mediumLocales
}: LanguagePickerLocaleSources): string[] {
  const defaultLng = ['en'];

  if (textLocales.includes('es')) {
    defaultLng.push('es');
  }

  return [
    ...new Set([
      ...defaultLng,
      ...subtitleLocales,
      ...mediumLocales,
      ...textLocales
    ])
  ];
}

/**
 * Locales offered on the main onboarding screen before opening the modal.
 * Keeps the historical ordering: en, es (when available), then text locales.
 */
export function getOnboardingTextLocales(textLocales: string[]): string[] {
  const defaultLng = ['en'];

  if (textLocales.includes('es')) {
    defaultLng.push('es');
  }

  return [...defaultLng, ...textLocales.filter(i => i !== 'en' && i !== 'es')];
}
